import { useCallback } from "react";
import {
  ColumnsWithGroupData,
  getColumnsWithGroup,
} from "../../../api/Windows";
import { useWorkOrderStore } from "../../../store/wo-order";

export default function useGetReturnDetailsColumns() {
  const setReturnColumns = useWorkOrderStore((state) => state.setReturnColumns);

  const getReturnDetailsColumns = useCallback(async () => {
    const data: ColumnsWithGroupData = {
      WindowName: "mob_inventory_return_details",
      IncludeValidValues: "true",
    };
    const response = await getColumnsWithGroup(data);
    setReturnColumns(response.data);
    return response;
  }, [setReturnColumns]);

  return { getReturnDetailsColumns };
}
